import type { MetaFunction } from '@remix-run/node';
import type { loader as professionalsLoader } from '~/routes/_app.professionals.$';
import type { loader as professionalsLoaderRocco } from '~/routes/_app.rocco.professionals.$';
import type { ListItem } from 'schema-dts';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';

export const createProfessionalsItemListSchema: MetaFunction<
    typeof professionalsLoader | typeof professionalsLoaderRocco,
    StaticParentLoaders
> = (props) => {
    const { data, location } = props;
    if (!data) {
        return [];
    }
    const baseUrl = getMetaBaseUrl(props);
    const itemListElement: ListItem[] =
        data.searchResult?.hits?.map((prof, idx) => {
            // const locations: LibraryLocation[] =
            //     prof.SearchLocations?.filter(
            //         (location) => location.LocationType !== 'ServiceArea'
            //     ) ?? [];
            // const selectedAddress: PostalAddress[] = locations.map((loc) => {
            //     return createPostalAddress(loc, prof.Country);
            // });

            return {
                '@type': 'ListItem',
                position: data.pagination?.currentRange?.from + idx,
                item: {
                    '@type': 'LocalBusiness',
                    name: prof.Title ?? '',
                    logo: baseUrl + prof.CompanyLogos?.Thumb_sm,
                    image: baseUrl + prof.Thumb_lg,
                    url: baseUrl + prof.Link,
                    // Do not add address for now because SearchLocations may return
                    // too many locations. Add back when we can get LibraryLocations only.
                    // address: selectedAddress,
                    // ...(mainLocation?.MapCoordinates && {
                    //     geo: {
                    //         '@type': 'GeoCoordinates',
                    //         latitude: mainLocation?.MapCoordinates?.Latitude,
                    //         longitude: mainLocation?.MapCoordinates?.Longitude,
                    //     },
                    // }),
                },
            };
        }) ?? [];
    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems: data.searchResult?.nbHits ?? 0,
            itemListElement,
        },
    ];
};
